import CONFIG from '../config/app';

export const getDefaultLanguage = () => {
  const language = window.navigator.language.slice(0, 2).toLowerCase();
  if (CONFIG.LANGUAGES.find((lang: string) => lang === language)) return language;
  return CONFIG.DEFAULT_LANG;
};
